<template>
  <!-- HORIZONTAL LAYOUT -->
  <vx-card title="Create Product Must Haves">
    <div class="vx-row mb-6" style="width: 50%">
      <vs-button
        class="ml-4 mt-2"
        color="danger"
        icon-pack="feather"
        icon="icon-arrow-left"
        @click="handleBack()"
        >Back</vs-button
      >
    </div>
    <div class="vx-row">
      <div class="vx-col sm:w-1/2 w-full mb-base">
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full">
            <span>Territory</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <multiselect
              class="selectExample"
              v-model="selectedTerritory"
              :options="optionTerritory"
              multiple
              :filterable="true"
              :allow-empty="true"
              :group-select="true"
              :max-height="100"
              :internal-search="false"
              placeholder="Type to search"
              :searchable="true"
              track-by="id"
              @search-change="handlerSearchChangeT"
              :custom-label="customLableTerritory"
            />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full">
            <span> Distribution Channel </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <multiselect
              class="selectExample"
              v-model="selectedDistributionChannel"
              :options="optionDistributionChannel"
              multiple
              :filterable="true"
              :allow-empty="true"
              :group-select="true"
              :max-height="100"
              :limit="3"
              :internal-search="false"
              placeholder="Type to search"
              :searchable="true"
              track-by="id"
              @search-change="handlerSearchChangeCC"
              :custom-label="customLableDistributionChannel"
            />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full">
            <span>Customer Group 1 </span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <multiselect
              class="selectExample"
              v-model="selectedCustomerGroup1"
              :options="optionCustomerGroup1"
              multiple
              :filterable="true"
              :allow-empty="true"
              :group-select="true"
              :max-height="100"
              :limit="3"
              :internal-search="false"
              placeholder="Type to search"
              :searchable="true"
              track-by="id"
              @search-change="handlerSearchChangeCG1"
              :custom-label="customLableCustomerGroup1"
            />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full">
            <span>Customer Group 2</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <multiselect
              class="selectExample"
              v-model="selectedCustomerGroup2"
              :options="optionCustomerGroup2"
              multiple
              :filterable="true"
              :allow-empty="true"
              :group-select="true"
              :max-height="100"
              :limit="3"
              :internal-search="false"
              placeholder="Type to search"
              :searchable="true"
              track-by="id"
              @search-change="handlerSearchChangeCG2"
              :custom-label="customLableCustomerGroup1"
            />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full">
            <span>Customer</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <multiselect
              class="selectExample"
              v-model="selectedCustomer"
              :options="optionCustomer"
              multiple
              :filterable="true"
              :allow-empty="true"
              :group-select="true"
              :max-height="100"
              :limit="3"
              :internal-search="false"
              placeholder="Type to search"
              :searchable="true"
              track-by="id"
              @search-change="handlerSearchChange"
              :custom-label="customLableCustomer"
            />
          </div>
          <div class="vx-col sm:w-1/6 w-full text-right">
            <vs-button
              size="medium"
              class="mr-2 mb-1 bg-success"
              icon-pack="feather"
              icon="icon-search"
              @click="handlerSearchGetCustomer()"
              >refresh</vs-button
            >
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full">
            <span>Salesman Type</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <multiselect
              class="selectExample"
              v-model="selectedTypeSalesman"
              :options="optionTypeSalesman"
              multiple
              :filterable="true"
              :allow-empty="true"
              :group-select="true"
              :max-height="100"
              :limit="3"
              :internal-search="false"
              placeholder="Type to search"
              :searchable="true"
              track-by="id"
              @search-change="handlerSearchChangeWp1"
              :custom-label="customLableWorkPosition"
            />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full">
            <span>Salesman Subtype</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <multiselect
              class="selectExample"
              v-model="selectedWorkPosition"
              :options="optionWorkPosition"
              multiple
              :filterable="true"
              :allow-empty="true"
              :group-select="true"
              :max-height="100"
              :limit="3"
              :internal-search="false"
              placeholder="Type to search"
              :searchable="true"
              track-by="id"
              @search-change="handlerSearchChangeWp2"
              :custom-label="customLableWorkPosition"
            />
          </div>
          <div class="vx-col sm:w-1/6 w-full text-right">
            <vs-button
              size="medium"
              class="mr-2 mb-1 bg-success"
              icon-pack="feather"
              icon="icon-search"
              @click="handlerSearchGetWorkPosition()"
              >refresh</vs-button
            >
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full">
            <span>Valid From - To</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <date-range-picker
              style="min-height: 40px"
              class="w-full"
              ref="picker"
              opens="center"
              :locale-data="{ firstDay: 1, format: 'dd Mon yyyy' }"
              :singleDatePicker="false"
              :timePicker="false"
              :timePicker24Hour="false"
              :showWeekNumbers="false"
              :showDropdowns="false"
              :autoApply="true"
              v-model="validity"
              :linkedCalendars="true"
            >
              <template v-slot:input="picker" style="min-width: 350px">
                {{ dateFormat(picker.startDate) }} -
                {{ dateFormat(picker.endDate) }}
              </template>
            </date-range-picker>
          </div>
        </div>

        <div class="vx-row mb-6" style="width: 50%">
          <div class="vx-col sm:w-1/3 w-full flex items-center">
            <span>Status</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <!-- <input type="radio" id="active" value="Active" v-model="status" />
            <label for="active">Active</label>

            <input
              type="radio"
              id="inactive"
              value="Inactive"
              v-model="status"
            />
            <label for="inactive">Inactive</label> -->
            <vs-switch width="120px" color="success" v-model="status">
              <span slot="on">Active</span>
              <span slot="off">Inactive</span>
            </vs-switch>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full">
            <span>Line Items</span>
          </div>
          <div class="vx-col sm:w-5/6 w-full">
            <vs-button size="small" class="mr-3 mb-2" @click="browseItem()"
              >Browse</vs-button
            >
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-6/12 w-full" v-if="update">
            <vs-button class="mr-3 mb-2" v-on:click="SubmitForm()"
              >Submit</vs-button
            >
            <!-- <vs-button v-if="quantityChecked != true" class="mr-3 mb-2" v-on:click="CheckQty()">CheckQty</vs-button> -->
            <!-- <vs-button color="danger" class="mr-3 mb-2" @click="CancelForm()"
              >Cancel</vs-button
            > -->
          </div>
        </div>
        <br />
        <hr />
        <br />
        <!-- <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <vs-table :data="cartProducts" stripe style="width: 100%">
              <template slot="thead">
                <vs-th>SKU</vs-th>
                <vs-th>Name</vs-th>
                <vs-th>Category</vs-th>
                <vs-th>Unit</vs-th>
                <vs-th>Quantity</vs-th>
                <vs-th>Action</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="index" v-for="(dt, index) in data">
                  <vs-td style="align-item-center">{{ dt.skuCode }}</vs-td>
                  <vs-td style="align-item-center">{{ dt.Name }}</vs-td>
                  <vs-td style="align-item-center">{{ dt.Categories }}</vs-td>
                  <vs-td style="align-item-center">
                    <vs-tr
                      v-for="(ds, idx1) in dt.itemUnitId"
                      :key="idx1"
                      style="align-item-center"
                      >{{ ds.Unit }}
                      <vs-input
                        type="number"
                        v-model.number="ds.value"
                        style="width: 100px"
                        @input="calculUnitToQty(ds, index, idx1)"
                      />
                    </vs-tr>
                  </vs-td>
                  <vs-td style="align-item-center">
                    <vs-input
                      type="number"
                      v-model.number="dt.qty"
                      :min="1"
                      style="width: 70px"
                      @input="calculateConversion(dt.qty, index)"
                    />
                  </vs-td>
                  <vs-td style="align-item-center">
                    <feather-icon
                      title="Delete"
                      icon="TrashIcon"
                      svgClasses="w-5 h-5 text-danger stroke-current"
                      class="ml-2"
                      @click="deleteItemLine(index)"
                    />
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div> -->
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <vs-table :data="cartProducts" stripe style="width: 100%">
              <template slot="thead">
                <vs-th>SKU</vs-th>
                <vs-th>Name</vs-th>
                <vs-th>Category</vs-th>
                <vs-th>Action</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="index" v-for="(dt, index) in data">
                  <vs-td style="align-item-center">{{ dt.skuCode }}</vs-td>
                  <vs-td style="align-item-center">{{ dt.Name }}</vs-td>
                  <vs-td style="align-item-center">{{ dt.Categories }}</vs-td>
                  <vs-td style="align-item-center">
                    <feather-icon
                      title="Delete"
                      icon="TrashIcon"
                      svgClasses="w-5 h-5 text-danger stroke-current"
                      class="ml-2"
                      @click="deleteItemLine(index)"
                    />
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>
      <div
        v-if="this.optionItemAvailableShow"
        class="vx-col sm:w-1/2 w-full mb-base"
      >
        <div class="vx-row mb-6">
          <h3>Item Unit</h3>
        </div>
        <vs-table
          search
          stripe
          border
          description
          :sst="true"
          :data="items"
          :max-items="length"
          :total="total"
          @search="handleSearch"
          @change-page="handleChangePage"
          @sort="handleSort"
        >
          <template slot="header">
            <vs-dropdown vs-trigger-click class="cursor-pointer">
              <div
                class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
              >
                <span class="mr-2"
                  >{{ this.start }} - {{ this.end }} of {{ this.total }}</span
                >
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu>
                <vs-dropdown-item
                  v-for="item in limits"
                  :key="item"
                  @click="handleChangelength(item)"
                >
                  <span>{{ item }}</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </template>
          <template slot="thead">
            <vs-th sort-key="sku">SKU</vs-th>
            <vs-th sort-key="name">Name</vs-th>
            <vs-th sort-key="name">Supplier</vs-th>
            <vs-th sort-key="name">Category</vs-th>
            <!-- <vs-th sort-key="name">Unit</vs-th> -->
            <vs-th sort-key="action">Action</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr
              :data="tr"
              :key="indextr"
              v-for="(tr, indextr) in data.records"
            >
              <vs-td :data="data.records[indextr].sku_code">{{
                data.records[indextr].sku_code
              }}</vs-td>
              <vs-td :data="data.records[indextr].item_name"
                >{{ data.records[indextr].item_name }}
              </vs-td>
              <vs-td :data="data.records[indextr].supplier_name"
                >{{ data.records[indextr].supplier_name }}
              </vs-td>
              <vs-td :data="data.records[indextr].categories_name"
                >{{ data.records[indextr].categories_name }}
              </vs-td>
              <!-- <vs-td :data="data.records[indextr].unit_name"
                >{{ data.records[indextr].unit_name }}
              </vs-td> -->
              <vs-td style="align-item-center">
                <feather-icon
                  title="Add"
                  icon="PlusIcon"
                  svgClasses="w-5 h-5 text-success stroke-current"
                  class="ml-2"
                  @click="addItemLine(tr)"
                />
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <vs-pagination
          style="padding-top: 5px"
          :total="totalPage"
          v-model="setPage"
        />
      </div>
    </div>
  </vx-card>
</template>

<script>
import ArrowUpDownBold from "vue-material-design-icons/ArrowUpDownBold.vue";
import PlusBox from "vue-material-design-icons/PlusBox.vue";

import draggable from "vuedraggable";

import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import moment from "moment";
import DateRangePicker from "vue2-daterange-picker";
import { debounce } from "lodash";

// how long typing has to settle before a dropdown asks the server again
const SEARCH_DEBOUNCE = 500;
// the cascade can change several levels at once, so let it settle before reloading
const CASCADE_DEBOUNCE = 300;
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
export default {
  components: {
    draggable,
    ArrowUpDownBold,
    PlusBox,
    Datepicker,
    vSelect,
    DateRangePicker,
  },
  created() {
    Object.keys(this.previousSelection).forEach((field) => {
      this.previousSelection[field] = this[field];
    });
  },
  beforeDestroy() {
    // drop anything still pending so leaving the page cannot fire one last request
    [
      "handlerSearchChange",
      "handlerSearchChangeT",
      "handlerSearchChangeCC",
      "handlerSearchChangeCG1",
      "handlerSearchChangeCG2",
      "handlerSearchChangeWp1",
      "handlerSearchChangeWp2",
      "reloadCustomer",
      "reloadWorkPosition",
    ].forEach((method) => this[method].cancel());
  },
  mounted() {
    // console.log("mounted - form : ", this.territoryCode, this.territoryId, this.selectedReservation, this.optionTerritory);
    this.update = true;
    this.getTerritory();
    this.handlerSearchGetCustomer();
    this.handlerSearchGetWorkPosition();
    this.getTypeSalesman();
    // this.getSalesChannel();
    this.getCustomerCategory();
    this.getCustomerGroup1();
    this.getCustomerGroup2();
  },
  computed: {
    setPage: {
      get() {
        return 1;
      },
      set(val) {
        this.handleChangePage(val);
      },
    },
  },
  watch: {
    search: function () {
      if (this.optionItemAvailableShow) {
        this.getOptionItemAvailable();
      }
    },
    itemsQuantity: function () {
      this.quantityChecked = false;
    },
    data: {
      handler: "calculateConversion",
      deep: true,
    },
    selectedTerritory: {
      handler(newValue) {
        if (this.syncAllOption("selectedTerritory", newValue)) {
          return;
        }

        this.onCustomerScopeChange();
      },
      deep: true,
    },
    selectedDistributionChannel: {
      handler(newValue) {
        if (this.syncAllOption("selectedDistributionChannel", newValue)) {
          return;
        }

        this.onCustomerScopeChange();
      },
      deep: true,
    },
    selectedCustomerGroup1: {
      handler(newValue) {
        if (this.syncAllOption("selectedCustomerGroup1", newValue)) {
          return;
        }

        this.onCustomerScopeChange();
      },
      deep: true,
    },
    selectedCustomerGroup2: {
      handler(newValue) {
        if (this.syncAllOption("selectedCustomerGroup2", newValue)) {
          return;
        }

        this.onCustomerScopeChange();
      },
      deep: true,
    },
    selectedCustomer: {
      handler(newValue) {
        this.syncAllOption("selectedCustomer", newValue);
      },
      deep: true,
    },
    selectedTypeSalesman: {
      handler(newValue) {
        if (this.syncAllOption("selectedTypeSalesman", newValue)) {
          return;
        }

        this.onTypeSalesmanChange();
      },
      deep: true,
    },
    selectedWorkPosition: {
      handler(newValue) {
        this.syncAllOption("selectedWorkPosition", newValue);
      },
      deep: true,
    },
  },
  data: () => ({
    update: false,
    quantityChecked: false,
    external: false,

    cartProducts: [],
    itemUnitID: [],
    // itemID: [],

    optionItemAvailable: [{}],

    optionCustomerShow: false,
    optionItemAvailableShow: false,

    limits: [10, 25, 50, 100, "All"],
    limitShow: 10,
    drawData: 0,
    isActive: 1,
    recordsTotal: 0,
    maxPage: 2,
    dataEnd: 0,

    items: [],
    optionTerritory: [],
    selectedTerritory: [{ code: "", name: "ALL", id: 0 }],
    optionWorkPosition: [],
    selectedWorkPosition: [{ Name: "ALL", id: 0 }],
    optionTypeSalesman: [],
    selectedTypeSalesman: [{ Name: "ALL", id: 0 }],
    optionCustomer: [],
    selectedCustomer: [{ code: "", name: "ALL", id: 0 }],
    optionDistributionChannel: [],
    selectedDistributionChannel: [
      {
        name: "ALL",
        classification: "",
        id: 0,
      },
    ],
    optionCustomerGroup1: [],
    selectedCustomerGroup1: [{ code: "", name: "ALL", id: 0 }],
    optionCustomerGroup2: [],
    selectedCustomerGroup2: [{ code: "", name: "ALL", id: 0 }],
    // last accepted value of each multiselect, used to tell "ALL was just picked"
    // apart from "a real option was picked while ALL was still selected"
    previousSelection: {
      selectedTerritory: [],
      selectedDistributionChannel: [],
      selectedCustomerGroup1: [],
      selectedCustomerGroup2: [],
      selectedCustomer: [],
      selectedTypeSalesman: [],
      selectedWorkPosition: [],
    },
    searchT: "",
    searchCc: "",
    searchCG1: "",
    searchCG2: "",
    searchCust: "",
    searchwp1: "",
    searchwp2: "",
    salesType: [],
    start: 1,
    end: 0,
    length: 10,
    page: 1,
    search: "",
    order: "id",
    sort: "desc",
    total: 0,
    totalPage: 0,
    totalSearch: 0,
    name: "",
    code: "",
    CompanyID: 0,
    disableTerritory: false,
    status: true,
    validity: {
      startDate: null,
      endDate: null,
    },
    minValidFrom: null,
    maxValidTo: null,
    pcs: 0,
    lusin: 0,
    karton: 0,
    inputValue: "",
    optionalItemUnit: [],
    selectedItemUnit: [],
  }),
  methods: {
    // calculUnitToQty(item, index, idx1) {
    //   console.log("KKKK", this.cartProducts[index].itemUnitId.length);
    //   let total = 0;

    //   this.cartProducts[index].itemUnitId.forEach((element) => {
    //     total += element.AmountUOM * element.value;
    //   });
    //   this.cartProducts[index].qty = total;
    // },
    // calculateConversion(item, index) {
    //   console.log("IIIIII", index);

    //   var arrayItem = [];
    //   arrayItem = this.cartProducts[index];
    //   arrayItem.itemUnitId.sort((a, b) => b.level - a.level);

    //   this.cartProducts[index].itemUnitId.forEach((ds) => {
    //     var amount_uom = ds.AmountUOM;

    //     const karton = Math.floor(item / amount_uom);
    //     item %= amount_uom;
    //     ds.value = karton;
    //   });
    // },
    // ids of the picked options, skipping the "ALL" entry (id 0) which means "no filter"
    selectedIds(selected) {
      if (!Array.isArray(selected)) {
        return [];
      }
      return selected.filter((item) => item && item.id).map((item) => item.id);
    },
    // "ALL" (id 0) can never sit next to a real option: picking a real option while ALL is
    // selected drops ALL, and picking ALL drops everything else. Returns true when the selection
    // had to be rewritten - the watcher then runs again with the corrected value.
    syncAllOption(field, selected) {
      if (!Array.isArray(selected)) {
        return false;
      }

      const others = selected.filter((item) => item && item.id !== 0);
      const hasAll = others.length !== selected.length;
      let next = selected;

      if (hasAll && others.length > 0) {
        const previous = this.previousSelection[field] || [];
        next = previous.some((item) => item && item.id === 0)
          ? others
          : [selected.find((item) => item && item.id === 0)];
      }

      this.previousSelection[field] = next;
      if (next === selected) {
        return false;
      }

      this[field] = next;
      return true;
    },
    // Territory, distribution channel, customer group 1 and customer group 2 are independent of
    // each other: each one lists its own master data in full and changing one never clears the
    // others. Only the levels that really have a parent above them follow a selection:
    // customer follows territory + distribution channel + customer group 1/2, and salesman
    // subtype follows salesman type. The reloads are debounced because several of the filters
    // above customer can change in the same tick.
    onCustomerScopeChange() {
      this.selectedCustomer = [{ code: "", name: "ALL", id: 0 }];
      this.reloadCustomer();
    },
    onTypeSalesmanChange() {
      this.selectedWorkPosition = [{ Name: "ALL", id: 0 }];
      this.reloadWorkPosition();
    },
    reloadCustomer: debounce(function () {
      this.handlerSearchGetCustomer();
    }, CASCADE_DEBOUNCE),
    reloadWorkPosition: debounce(function () {
      this.handlerSearchGetWorkPosition();
    }, CASCADE_DEBOUNCE),
    handleBack() {
      this.$router.push({
        name: "product-must-haves",
      });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    browseItem() {
      this.search = "";
      this.optionItemAvailableShow = true;
      this.optionCustomerShow = false;
      this.getOptionItemAvailable();
      this.scrollToTop();
    },
    addItemLine(item) {
      // console.log("ini itemLine>>>",);
      this.quantityChecked = false;
      let check = this.itemUnitID.filter((val) => {
        return item.id == val;
      });
      console.log(check);

      if (check.length == 0) {
        this.cartProducts.push({
          // itemUnitId: item.id,
          itemId: item.item_id,
          skuCode: item.sku_code,
          Categories: item.categories_name,
          Name: item.item_name,
          item_unit_id: item.id,
          // Unit: item.unit_name,
          // qty: 1,
        });
        this.itemUnitID.push(item.id);
      } else {
        this.$vs.notify({
          title: "Warning",
          text: "You're not allowed to add or remove external Reservation item line ",
          color: "warning",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-check",
        });
      }
    },
    // addItemLine(item) {
    //   // console.log("ini itemLine>>>",);
    //   this.quantityChecked = false;
    //   let check = this.itemUnitID.filter((val) => {
    //     return item.id == val;
    //   });
    //   console.log(check);
    //   this.$http
    //     .get("/api/sfa/v1/product-must-haves/item-unit", {
    //       params: {
    //         search: this.searchwp1,
    //         itemId: item.item_id,
    //       },
    //     })
    //     .then((resp) => {
    //       if (resp.code == 200) {
    //         if (resp.data.records) {
    //           this.optionalItemUnit = [];
    //           var cartProductChild = [];
    //           for (let index = 0; index < resp.data.records.length; index++) {
    //             cartProductChild.push({
    //               itemUnitId: resp.data.records[index].id,
    //               level: resp.data.records[index].level,
    //               itemId: resp.data.records[index].item_id,
    //               skuCode: resp.data.records[index].item.sku_code,
    //               Name: resp.data.records[index].item.name,
    //               Unit: resp.data.records[index].unit.Name,
    //               AmountUOM: resp.data.records[index].amount_uom,
    //               value: 0,
    //               total: 0,
    //             });
    //           }
    //           if (check.length == 0) {
    //             this.cartProducts.push({
    //               itemUnitId: cartProductChild,
    //               itemId: item.item_id,
    //               skuCode: item.sku_code,
    //               Categories: item.categories_name,
    //               Name: item.item_name,
    //               Unit: item.unit_name,
    //               qty: 1,
    //             });
    //             this.itemUnitID.push(item.id);
    //             console.log("MMMM", this.cartProducts);
    //           } else {
    //             this.$vs.notify({
    //               title: "Warning",
    //               text: "You're not allowed to add or remove external Reservation item line ",
    //               color: "warning",
    //               position: "top-right",
    //               iconPack: "feather",
    //               icon: "icon-check",
    //             });
    //           }
    //         } else {
    //           this.optionalItemUnit = [];
    //           this.selectedItemUnit = {};
    //         }
    //         this.$vs.loading.close();
    //       } else {
    //         this.$vs.loading.close();
    //       }
    //     });
    // },
    deleteItemLine(index) {
      this.quantityChecked = false;
      if (this.external == false) {
        this.cartProducts.splice(index, 1);
        this.itemID.splice(index, 1);
      } else {
        this.$vs.notify({
          title: "Warning",
          text: "You're not allowed to add or remove external Reservation item line",
          color: "warning",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-check",
        });
      }
    },
    handleChangelength(val) {
      this.length = val == "All" ? this.total : val;
      this.page = 1;
      this.getOptionItemAvailable();
    },
    getOptionItemAvailable(page = 1) {
      this.isActive = page;

      this.$http
        .get("/api/sfa/v1/product-must-haves/table", {
          params: {
            territory_id: this.selectedTerritory.id,
            length: this.length,
            page: this.page,
            search: this.search,
            order: this.order,
            sort: this.sort,
          },
        })
        .then((resp) => {
          console.log(">>>>>>>>", resp);
          if (resp.code == 200) {
            let company_id = this.$store.state.user.currentUser.company_id;

            this.optionItemAvailable = resp.data.ItemsAvailable;
            this.total = resp.data.total_record;
            this.totalPage = resp.data.total_page;
            this.totalSearch = resp.data.total_record_search;
            this.length = resp.data.total_record_per_page;
            this.items = resp.data;
            this.CompanyID = company_id;
            this.setStartEnd();
            this.$vs.loading.close();
          } else {
            this.$vs.notify({
              title: "Error",
              text: "Failed to get Item Available",
              color: "danger",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-check",
            });
          }
          this.$vs.loading.close();
        });
    },
    SubmitForm() {
      if (this.cartProducts.length == 0) {
        this.$vs.notify({
          title: "Error",
          text: "Please select Item Line first",
          color: "danger",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-check",
        });
        return true;
      }
      if (
        this.selectedTerritory.length == 0 ||
        this.selectedDistributionChannel.length == 0 ||
        this.selectedWorkPosition.length == 0 ||
        this.selectedTypeSalesman.length == 0 ||
        this.selectedCustomerGroup1.length == 0 ||
        this.selectedCustomerGroup2.length == 0
      ) {
        this.$vs.notify({
          title: "Error",
          text: "Make sure all the form data is filled in",
          color: "danger",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-check",
        });
        return true;
      }
      let TerritoryIDs = [];
      this.selectedTerritory.forEach((element) => {
        TerritoryIDs.push(element.id);
      });
      let TypesalesmanIDs = [];
      this.selectedTypeSalesman.forEach((element) => {
        TypesalesmanIDs.push(element.id);
      });
      let WorkPositionIDs = [];
      this.selectedWorkPosition.forEach((element) => {
        WorkPositionIDs.push(element.id);
      });
      let CustomerCategoryIDs = [];
      this.selectedDistributionChannel.forEach((element) => {
        CustomerCategoryIDs.push(element.id);
      });
      let CustomerGroup1IDs = [];
      this.selectedCustomerGroup1.forEach((element) => {
        CustomerGroup1IDs.push(element.id);
      });
      let CustomerGroup2IDs = [];
      this.selectedCustomerGroup2.forEach((element) => {
        CustomerGroup2IDs.push(element.id);
      });
      let CustomerIDs = [];
      this.selectedCustomer.forEach((element) => {
        CustomerIDs.push(element.id);
      });

      this.$vs.loading();
      this.$http
        .post("/api/sfa/v1/product-must-haves/store", {
          code: this.code,
          territory_id: TerritoryIDs,
          customer_category_id: CustomerCategoryIDs,
          work_position_id: WorkPositionIDs,
          type_salesman_id: TypesalesmanIDs,
          customer_group_id_1: CustomerGroup1IDs,
          customer_group_id_2: CustomerGroup2IDs,
          // sales_channel_id: this.selectedSalesChannel.id,
          customer_id: CustomerIDs,
          company_id: this.CompanyID,
          item_id: this.cartProducts,
          status: this.status
            ? this.status == true
              ? "Active"
              : "Inactive"
            : "Inactive",
          valid_from: this.validity.startDate
            ? moment(this.validity.startDate).format("YYYY-MM-DD")
            : null,
          valid_to: this.validity.endDate
            ? moment(this.validity.endDate).format("YYYY-MM-DD")
            : null,
        })
        .then((resp) => {
          console.log(resp);
          if (resp.code == 200) {
            this.$vs.notify({
              title: "Success",
              text: "Reservation has been added",
              color: "success",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-check",
            });
            this.handleBack();
          } else {
            this.$vs.notify({
              title: "Error",
              text: resp.message,
              color: "danger",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-check",
            });
          }

          this.$vs.loading.close();
        });
    },
    getCustomer() {
      this.$vs.loading();
      this.$http
        .get("/api/sfa/v1/product-must-haves/customer", {
          params: {
            length: 40,
            // page: this.table.page,
            search: this.searchCust,
            // order: this.table.order,
            // sort: this.table.sort,
            territory_id: this.selectedIds(this.selectedTerritory),
            customer_category_id: this.selectedIds(
              this.selectedDistributionChannel
            ),
            customer_group_id_1: this.selectedIds(this.selectedCustomerGroup1),
            customer_group_id_2: this.selectedIds(this.selectedCustomerGroup2),
          },
        })
        .then((resp) => {
          if (resp.code == 200) {
            if (resp.data.records) {
              this.optionCustomer = [{ code: "", name: "ALL", id: 0 }];
              for (let index = 0; index < resp.data.records.length; index++) {
                this.optionCustomer.push(resp.data.records[index]);
              }
              // this.optionCustomer = resp.data.records;
              if (this.optionCustomer.length > 0) {
                // this.selectedCustomer = this.optionCustomer[0];
              } else {
                this.optionCustomer = [{ code: "", name: "ALL", id: 0 }];
              }
            } else {
              this.optionCustomer = [{ code: "", name: "ALL", id: 0 }];
            }
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
          }
        });
    },
    getCustomerGroup2() {
      this.$vs.loading();
      this.$http
        .get("/api/sfa/v1/product-must-haves/customer-group", {
          params: {
            length: 40,
            order: "name",
            sort: "asc",
            level: 2,
            search: this.searchCG2,
          },
        })
        .then((resp) => {
          if (resp.code == 200) {
            if (resp.data.records) {
              this.optionCustomerGroup2 = [];
              this.optionCustomerGroup2.push({ code: "", name: "ALL", id: 0 });
              for (let index = 0; index < resp.data.records.length; index++) {
                this.optionCustomerGroup2.push(resp.data.records[index]);
              }
              // this.optionCustomerGroup2 = resp.data.records;
              if (this.optionCustomerGroup2.length > 0) {
                // this.selectedCustomerGroup2 = this.optionCustomerGroup2[0];
              } else {
                this.optionCustomerGroup2 = [{ code: "", name: "ALL", id: 0 }];
              }
            } else {
              this.optionCustomerGroup2 = [{ code: "", name: "ALL", id: 0 }];
            }
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
          }
        });
    },
    getCustomerGroup1() {
      this.$vs.loading();
      this.$http
        .get("/api/sfa/v1/product-must-haves/customer-group", {
          params: {
            length: 40,
            order: "name",
            sort: "asc",
            level: 1,
            search: this.searchCG1,
          },
        })
        .then((resp) => {
          if (resp.code == 200) {
            if (resp.data.records) {
              this.optionCustomerGroup1 = [];
              this.optionCustomerGroup1.push({ code: "", name: "ALL", id: 0 });
              for (let index = 0; index < resp.data.records.length; index++) {
                this.optionCustomerGroup1.push(resp.data.records[index]);
              }
              // this.optionCustomerGroup1 = resp.data.records;
              if (this.optionCustomerGroup1.length > 0) {
                // this.selectedCustomerGroup1 = this.optionCustomerGroup1[0];
              } else {
                this.optionCustomerGroup1 = [{ code: "", name: "ALL", id: 0 }];
              }
            } else {
              this.optionCustomerGroup1 = [{ code: "", name: "ALL", id: 0 }];
            }
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
          }
        });
    },
    getTypeSalesman() {
      this.$vs.loading();
      this.$http
        .get("/api/sfa/v1/product-must-haves/type-salesman", {
          params: {
            length: 9999,
            order: "name",
            sort: "asc",
            search: this.searchwp1,
          },
        })
        .then((resp) => {
          if (resp.code == 200) {
            if (resp.data.records) {
              this.optionTypeSalesman = [{ Name: "ALL", id: 0 }];
              for (let index = 0; index < resp.data.records.length; index++) {
                this.optionTypeSalesman.push(resp.data.records[index]);
              }
              // this.optionTypeSalesman = resp.data.records;
              if (this.optionTypeSalesman.length > 0) {
                // this.selectedTypeSalesman = this.optionTypeSalesman[0];
              } else {
                this.optionTypeSalesman = [];
                this.selectedTypeSalesman = {};
              }
            } else {
              this.optionTypeSalesman = [];
              this.selectedTypeSalesman = {};
            }
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
          }
        });
    },
    getWorkPosition() {
      this.$vs.loading();
      this.$http
        .get("/api/sfa/v1/product-must-haves/work-position", {
          params: {
            length: 9999,
            order: "name",
            sort: "asc",
            search: this.searchwp2,
            sales_type: this.salesType,
          },
        })
        .then((resp) => {
          if (resp.code == 200) {
            if (resp.data.records) {
              this.optionWorkPosition = [{ Name: "ALL", id: 0 }];
              for (let index = 0; index < resp.data.records.length; index++) {
                this.optionWorkPosition.push(resp.data.records[index]);
              }
              // this.optionWorkPosition = resp.data.records;
              if (this.optionWorkPosition.length > 0) {
                // this.selectedWorkPosition = this.optionWorkPosition[0];
              } else {
                this.optionWorkPosition = [];
                this.selectedWorkPosition = {};
              }
            } else {
              this.optionWorkPosition = [];
              this.selectedWorkPosition = {};
            }
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
          }
        });
    },
    getCustomerCategory() {
      this.$vs.loading();
      this.$http
        .get("/api/sfa/v1/product-must-haves/customer-category", {
          params: {
            length: 40,
            order: "name",
            sort: "asc",
            search: this.searchCc,
          },
        })
        .then((resp) => {
          if (resp.code == 200) {
            this.optionDistributionChannel = [];
            if (resp.data.records) {
              this.optionDistributionChannel.push({
                name: "ALL",
                classification: "",
                id: 0,
              });
              for (let index = 0; index < resp.data.records.length; index++) {
                this.optionDistributionChannel.push(resp.data.records[index]);
              }
              // this.optionDistributionChannel = resp.data.records;
              if (this.optionDistributionChannel.length > 0) {
                // this.selectedDistributionChannel =
                //   this.optionDistributionChannel[0];
              } else {
                this.optionDistributionChannel = [
                  { name: "ALL", classification: "", id: 0 },
                ];
              }
            } else {
              this.optionDistributionChannel = [
                { name: "ALL", classification: "", id: 0 },
              ];
            }
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
          }
        });
    },
    getTerritory() {
      this.$vs.loading();
      this.$http
        .get("/api/sfa/v1/territory", {
          params: {
            // length: 0,
            // order: "name",
            // sort: "asc",
            search: this.searchT,
          },
        })
        .then((resp) => {
          if (resp.code == 200) {
            if (resp.data.records) {
              this.optionTerritory = [{ code: "", name: "ALL", id: 0 }];
              for (let index = 0; index < resp.data.records.length; index++) {
                this.optionTerritory.push(resp.data.records[index]);
              }
              if (this.optionTerritory.length > 0) {
                // this.selectedTerritory = this.optionTerritory[0];
              } else {
                this.optionTerritory = [];
                this.selectedTerritory = {};
              }
            } else {
              this.optionTerritory = [];
              this.selectedTerritory = {};
            }
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
          }
        });
    },
    customLableTerritory({ code, name }) {
      return `${code} ${name}`;
    },
    customLableSalesChannel({ code, name }) {
      return `${code} ${name}`;
    },
    customLableDistributionChannel({ name, classification }) {
      return `${name} ${classification}`;
    },
    customLableCustomer({ code, name }) {
      return `${code} ${name}`;
    },
    customLableCustomerGroup1({ code, name }) {
      return `${code} ${name}`;
    },
    customLableWorkPosition({ Name }) {
      return `${Name}`;
    },
    setStartEnd() {
      let valStart = this.length * this.page - this.length + 1;
      if (valStart > this.total) {
        valStart = 1;
      }
      if (this.total == 0) {
        valStart = 0;
      }
      let valEnd = this.length * this.page;
      if (valEnd > this.total) {
        valEnd = this.total;
      }
      if (this.totalSearch < this.total) {
        valEnd = this.totalSearch;
      }

      this.start = valStart;
      this.end = valEnd;
    },
    handleSearch(searching) {
      this.search = searching;
      this.page = 1;
      this.getOptionItemAvailable(this.isActive);
    },
    handleChangePage(page) {
      this.page = page;
      this.getOptionItemAvailable(this.isActive);
    },
    handleSort(key, active) {
      this.order = key;
      this.sort = active;
      this.getOptionItemAvailable(this.isActive);
    },
    // every keystroke used to fire a request and blank the list while it was in flight;
    // wait for the typing to settle and skip the repeats multiselect emits on open/close
    handlerSearchChange: debounce(function (search) {
      if (this.searchCust === search) {
        return;
      }
      this.searchCust = search;
      this.getCustomer();
    }, SEARCH_DEBOUNCE),
    handlerSearchGetWorkPosition() {
      this.optionWorkPosition = [];

      let TypeSales = [];
      this.selectedTypeSalesman.forEach((element) => {
        if (element.id != 0) {
          TypeSales.push(element.id);
        }
      });
      this.salesType = TypeSales;
      this.getWorkPosition();
    },
    handlerSearchGetCustomer() {
      this.optionCustomer = [];
      this.getCustomer();
    },
    handlerSearchChangeWp1: debounce(function (searching) {
      if (this.searchwp1 === searching) {
        return;
      }
      this.searchwp1 = searching;
      this.getTypeSalesman();
    }, SEARCH_DEBOUNCE),
    handlerSearchChangeWp2: debounce(function (searching) {
      if (this.searchwp2 === searching) {
        return;
      }
      this.searchwp2 = searching;
      this.getWorkPosition();
    }, SEARCH_DEBOUNCE),
    handlerSearchChangeCC: debounce(function (searching) {
      if (this.searchCc === searching) {
        return;
      }
      this.searchCc = searching;
      this.getCustomerCategory();
    }, SEARCH_DEBOUNCE),
    handlerSearchChangeCG2: debounce(function (searching) {
      if (this.searchCG2 === searching) {
        return;
      }
      this.searchCG2 = searching;
      this.getCustomerGroup2();
    }, SEARCH_DEBOUNCE),
    handlerSearchChangeCG1: debounce(function (searching) {
      if (this.searchCG1 === searching) {
        return;
      }
      this.searchCG1 = searching;
      this.getCustomerGroup1();
    }, SEARCH_DEBOUNCE),
    handlerSearchChangeT: debounce(function (searching) {
      if (this.searchT === searching) {
        return;
      }
      this.searchT = searching;
      this.getTerritory();
    }, SEARCH_DEBOUNCE),
    dateFormat(date) {
      let a = null;
      if (date != null) {
        a = moment(date).format("DD MMM YYYY");
      }
      return a;
    },
  },
};
</script>
